import { AttachMoney} from '@mui/icons-material'

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const earnWalletInvestment = {
    id: 'earnWalletInvestment',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'earnWalletInvestment',
            title: 'Earn Wallet Investment',
            type: 'item',
            url: '/earnWalletInvestment',
            icon: AttachMoney,
            breadcrumbs: false
        },
       
    ]
};

export default earnWalletInvestment;
